export const seeds = [
  {
    id: 'strawberry',
    name: 'Strawberry',
    grades: {
      common: { plantingDelay: 120, sellingPrice: 1 }, // delay in seconds
      uncommon: { plantingDelay: 120, sellingPrice: 2 },
      rare: { plantingDelay: 120, sellingPrice: 3 },
      epic: { plantingDelay: 120, sellingPrice: 7 },
      legendary: { plantingDelay: 120, sellingPrice: 13 },
    },
  },
  {
    id: 'peas',
    name: 'Peas',
    grades: {
      common: { plantingDelay: 240, sellingPrice: 1 }, // delay in seconds
      uncommon: { plantingDelay: 240, sellingPrice: 2 },
      rare: { plantingDelay: 240, sellingPrice: 3 },
      epic: { plantingDelay: 240, sellingPrice: 4 },
      legendary: { plantingDelay: 240, sellingPrice: 7 },
    },
  },
  {
    id: 'corn',
    name: 'Corn',
    grades: {
      common: { plantingDelay: 360, sellingPrice: 2 }, // delay in seconds
      uncommon: { plantingDelay: 360, sellingPrice: 3 },
      rare: { plantingDelay: 360, sellingPrice: 4 },
      epic: { plantingDelay: 360, sellingPrice: 5 },
      legendary: { plantingDelay: 360, sellingPrice: 9 },
    },
  },
  {
    id: 'eggplant',
    name: 'Eggplant',
    grades: {
      common: { plantingDelay: 1020, sellingPrice: 8 }, // delay in seconds
      uncommon: { plantingDelay: 1020, sellingPrice: 18 },
      rare: { plantingDelay: 1020, sellingPrice: 30 },
      epic: { plantingDelay: 1020, sellingPrice: 61 },
      legendary: { plantingDelay: 1020, sellingPrice: 129 },
    },
  },
  {
    id: 'watermelon',
    name: 'Watermelon',
    grades: {
      common: { plantingDelay: 6720, sellingPrice: 51 }, // delay in seconds
      uncommon: { plantingDelay: 6720, sellingPrice: 100 },
      rare: { plantingDelay: 6720, sellingPrice: 196 },
      epic: { plantingDelay: 6720, sellingPrice: 412 },
      legendary: { plantingDelay: 6720, sellingPrice: 825 },
    },
  },
  {
    id: 'black_lotus ',
    name: 'Black Lotus',
    grades: {
      common: { plantingDelay: 43200, sellingPrice: 400 }, // delay in seconds
      uncommon: { plantingDelay: 43200, sellingPrice: 900 },
      rare: { plantingDelay: 43200, sellingPrice: 2100 },
      epic: { plantingDelay: 43200, sellingPrice: 4800 },
      legendary: { plantingDelay: 43200, sellingPrice: 10050 },
    },
  },
  {
    id: 'sunflower',
    name: 'Sunflower',
    grades: {
      common: { plantingDelay: 3600, sellingPrice: 32 }, // delay in seconds
      uncommon: { plantingDelay: 3600, sellingPrice: 70 },
      rare: { plantingDelay: 3600, sellingPrice: 166 },
      epic: { plantingDelay: 3600, sellingPrice: 376 },
      legendary: { plantingDelay: 3600, sellingPrice: 874 },
    },
  },
  {
    id: 'holly_seeds',
    name: 'Holly seeds',
    grades: {
      common: { plantingDelay: 10800, sellingPrice: 91 }, // delay in seconds
      uncommon: { plantingDelay: 10800, sellingPrice: 180 },
      rare: { plantingDelay: 10800, sellingPrice: 369 },
      epic: { plantingDelay: 10800, sellingPrice: 701 },
      legendary: { plantingDelay: 10800, sellingPrice: 1402 },
    },
  },
  {
    id: 'white_lily',
    name: 'White Lily',
    grades: {
      common: { plantingDelay: 18000, sellingPrice: 190 }, // delay in seconds
      uncommon: { plantingDelay: 18000, sellingPrice: 400 },
      rare: { plantingDelay: 18000, sellingPrice: 970 },
      epic: { plantingDelay: 18000, sellingPrice: 2170 },
      legendary: { plantingDelay: 18000, sellingPrice: 4595 },
    },
  },
  {
    id: 'radish',
    name: 'Radish',
    grades: {
      common: { plantingDelay: 480, sellingPrice: 2 }, // delay in seconds
      uncommon: { plantingDelay: 480, sellingPrice: 4 },
      rare: { plantingDelay: 480, sellingPrice: 6 },
      epic: { plantingDelay: 480, sellingPrice: 10 },
      legendary: { plantingDelay: 480, sellingPrice: 16 },
    },
  },
  {
    id: 'broccoli',
    name: 'Broccoli',
    grades: {
      common: { plantingDelay: 19680, sellingPrice: 142 }, // delay in seconds
      uncommon: { plantingDelay: 19680, sellingPrice: 280 },
      rare: { plantingDelay: 19680, sellingPrice: 569 },
      epic: { plantingDelay: 19680, sellingPrice: 1137 },
      legendary: { plantingDelay: 19680, sellingPrice: 2282 },
    },
  },
  {
    id: 'cabbage',
    name: 'Cabbage',
    grades: {
      common: { plantingDelay: 780, sellingPrice: 3 }, // delay in seconds
      uncommon: { plantingDelay: 780, sellingPrice: 5 },
      rare: { plantingDelay: 780, sellingPrice: 8 },
      epic: { plantingDelay: 780, sellingPrice: 13 },
      legendary: { plantingDelay: 780, sellingPrice: 21 },
    },
  },
  {
    id: 'cauliflower',
    name: 'Cauliflower',
    grades: {
      common: { plantingDelay: 1920, sellingPrice: 15 }, // delay in seconds
      uncommon: { plantingDelay: 1920, sellingPrice: 27 },
      rare: { plantingDelay: 1920, sellingPrice: 61 },
      epic: { plantingDelay: 1920, sellingPrice: 113 },
      legendary: { plantingDelay: 1920, sellingPrice: 219 },
    },
  },
  {
    id: 'onion',
    name: 'Onion',
    grades: {
      common: { plantingDelay: 900, sellingPrice: 7 }, // delay in seconds
      uncommon: { plantingDelay: 900, sellingPrice: 13 },
      rare: { plantingDelay: 900, sellingPrice: 26 },
      epic: { plantingDelay: 900, sellingPrice: 52 },
      legendary: { plantingDelay: 900, sellingPrice: 108 },
    },
  },
  {
    id: 'bell_pepper',
    name: 'Bell pepper',
    grades: {
      common: { plantingDelay: 3780, sellingPrice: 29 }, // delay in seconds
      uncommon: { plantingDelay: 3780, sellingPrice: 58 },
      rare: { plantingDelay: 3780, sellingPrice: 119 },
      epic: { plantingDelay: 3780, sellingPrice: 234 },
      legendary: { plantingDelay: 3780, sellingPrice: 335 },
    },
  },
  {
    id: 'chili_pepper',
    name: 'Chili pepper',
    grades: {
      common: { plantingDelay: 10860, sellingPrice: 81 }, // delay in seconds
      uncommon: { plantingDelay: 10860, sellingPrice: 159 },
      rare: { plantingDelay: 10860, sellingPrice: 320 },
      epic: { plantingDelay: 10860, sellingPrice: 637 },
      legendary: { plantingDelay: 10860, sellingPrice: 1285 },
    },
  },
  {
    id: 'sweet_potato',
    name: 'Sweet potato',
    grades: {
      common: { plantingDelay: 14640, sellingPrice: 107 }, // delay in seconds
      uncommon: { plantingDelay: 14640, sellingPrice: 215 },
      rare: { plantingDelay: 14640, sellingPrice: 422 },
      epic: { plantingDelay: 14640, sellingPrice: 847 },
      legendary: { plantingDelay: 14640, sellingPrice: 1701 },
    },
  },
  {
    id: 'garlic',
    name: 'Garlic',
    grades: {
      common: { plantingDelay: 4680, sellingPrice: 36 }, // delay in seconds
      uncommon: { plantingDelay: 4680, sellingPrice: 59 },
      rare: { plantingDelay: 4680, sellingPrice: 117 },
      epic: { plantingDelay: 4680, sellingPrice: 232 },
      legendary: { plantingDelay: 4680, sellingPrice: 405 },
    },
  },
  {
    id: 'ginger',
    name: 'Ginger',
    grades: {
      common: { plantingDelay: 28140, sellingPrice: 198 }, // delay in seconds
      uncommon: { plantingDelay: 28140, sellingPrice: 402 },
      rare: { plantingDelay: 28140, sellingPrice: 793 },
      epic: { plantingDelay: 28140, sellingPrice: 1587 },
      legendary: { plantingDelay: 28140, sellingPrice: 3161 },
    },
  },
  {
    id: 'snowdrop',
    name: 'Snowdrop',
    grades: {
      common: { plantingDelay: 9360, sellingPrice: 70 }, // delay in seconds
      uncommon: { plantingDelay: 9360, sellingPrice: 141 },
      rare: { plantingDelay: 9360, sellingPrice: 276 },
      epic: { plantingDelay: 9360, sellingPrice: 560 },
      legendary: { plantingDelay: 9360, sellingPrice: 1116 },
    },
  },
  {
    id: 'Mangold',
    name: 'Mangold',
    grades: {
      common: { plantingDelay: 5400, sellingPrice: 41 }, // delay in seconds
      uncommon: { plantingDelay: 5400, sellingPrice: 80 },
      rare: { plantingDelay: 5400, sellingPrice: 163 },
      epic: { plantingDelay: 5400, sellingPrice: 325 },
      legendary: { plantingDelay: 5400, sellingPrice: 646 },
    },
  },
  {
    id: 'Leek',
    name: 'Leek',
    grades: {
      common: { plantingDelay: 2700, sellingPrice: 21 }, // delay in seconds
      uncommon: { plantingDelay: 2700, sellingPrice: 43 },
      rare: { plantingDelay: 2700, sellingPrice: 82 },
      epic: { plantingDelay: 2700, sellingPrice: 165 },
      legendary: { plantingDelay: 2700, sellingPrice: 337 },
    },
  },
  {
    id: 'Spinach',
    name: 'Spinach',
    grades: {
      common: { plantingDelay: 1380, sellingPrice: 11 }, // delay in seconds
      uncommon: { plantingDelay: 1380, sellingPrice: 22 },
      rare: { plantingDelay: 1380, sellingPrice: 46 },
      epic: { plantingDelay: 1380, sellingPrice: 89 },
      legendary: { plantingDelay: 1380, sellingPrice: 179 },
    },
  },
  {
    id: 'daikon',
    name: 'Daikon',
    grades: {
      common: { plantingDelay: 12900, sellingPrice: 95 }, // delay in seconds
      uncommon: { plantingDelay: 12900, sellingPrice: 189 },
      rare: { plantingDelay: 12900, sellingPrice: 376 },
      epic: { plantingDelay: 12900, sellingPrice: 759 },
      legendary: { plantingDelay: 12900, sellingPrice: 1532 },
    },
  },
  {
    id: 'Cucumber',
    name: 'Cucumber',
    grades: {
      common: { plantingDelay: 900, sellingPrice: 11 }, // delay in seconds
      uncommon: { plantingDelay: 840, sellingPrice: 16 },
      rare: { plantingDelay: 780, sellingPrice: 32 },
      epic: { plantingDelay: 720, sellingPrice: 65 },
      legendary: { plantingDelay: 600, sellingPrice: 107 },
    },
  },
  {
    id: 'Mint',
    name: 'Mint',
    grades: {
      common: { plantingDelay: 3600, sellingPrice: 30 }, // delay in seconds
      uncommon: { plantingDelay: 3300, sellingPrice: 74 },
      rare: { plantingDelay: 3000, sellingPrice: 140 },
      epic: { plantingDelay: 2400, sellingPrice: 250 },
      legendary: { plantingDelay: 1800, sellingPrice: 360 },
    },
  },
  {
    id: 'Blueberry',
    name: 'Blueberry',
    grades: {
      common: { plantingDelay: 5400, sellingPrice: 47 }, // delay in seconds
      uncommon: { plantingDelay: 5100, sellingPrice: 83 },
      rare: { plantingDelay: 4800, sellingPrice: 250 },
      epic: { plantingDelay: 4200, sellingPrice: 475 },
      legendary: { plantingDelay: 3600, sellingPrice: 827 },
    },
  },
  {
    id: 'purple_carrot',
    name: 'Purple carrot',
    grades: {
      common: { plantingDelay: 10800, sellingPrice: 95 }, // delay in seconds
      uncommon: { plantingDelay: 9000, sellingPrice: 156 },
      rare: { plantingDelay: 8400, sellingPrice: 280 },
      epic: { plantingDelay: 7800, sellingPrice: 940 },
      legendary: { plantingDelay: 7200, sellingPrice: 1733 },
    },
  },
  {
    id: 'melon',
    name: 'Melon',
    grades: {
      common: { plantingDelay: 18000, sellingPrice: 47 }, // delay in seconds
      uncommon: { plantingDelay: 17400, sellingPrice: 83 },
      rare: { plantingDelay: 16800, sellingPrice: 250 },
      epic: { plantingDelay: 15600, sellingPrice: 475 },
      legendary: { plantingDelay: 14400, sellingPrice: 827 },
    },
  },
  // ... add more seeds like 'wheat', 'carrot', etc.
];
